import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "my-contracts-page" }
const _hoisted_2 = { class: "my-contracts-header d-flex justify-content-between align-items-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "me-3" }
const _hoisted_6 = { class: "element-box my-contracts-content" }
const _hoisted_7 = {
  key: 0,
  class: "alert alert-info"
}
const _hoisted_8 = { class: "mb-2" }
const _hoisted_9 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_10 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_11 = {
  key: 2,
  class: "alert alert-warning mb-0"
}

import {computed, onMounted, ref} from 'vue';
import router from '@/router';
import {piniaUserStore} from '@/store/piniaUserStore';
import {piniaCompanySettingsStore} from '@/store/piniaCompanySettingsStore';
import {ErrorToast} from '@/components/VueToast';
import BackButton from '@/components/button/BackButton.vue';
import Loader from '@/components/Loader.vue';
import userContractService from '@/api/UserContract';
import ContractDocumentView from '@/views/App/MyContracts/ContractDocumentView.vue';
import ContractList from '@/views/App/MyContracts/ContractList.vue';

// Own layout (no menu, top bar and notification polling): a user without signed contract
// can call only a few API routes, everything else returns 403 "contract_not_signed"

export default /*@__PURE__*/_defineComponent({
  __name: 'MyContractsView',
  setup(__props) {

const userStore = piniaUserStore();
const companySettingsStore = piniaCompanySettingsStore();

const currentUser = computed(() => userStore.currentUser.user);
const companySettings = computed(() => companySettingsStore.companySettings);

const contracts = ref<any[]>([]);
const isLoaded = ref(false);
const selectedDocumentId = ref<number | null>(null);

const allSignedByUser = computed(() =>
    contracts.value.length > 0 && contracts.value.every((contract) => contract.signedByUser)
);

async function handleSigned(document: any) {
  // The last signature (BSG signed before) completes the contract and enables the user
  if (document.userEnabled && currentUser.value?.enabled === false) {
    await userStore.piniaGetUser();
  }
  await loadContracts();
}

async function loadContracts() {
  try {
    const {data} = await userContractService.getMyContracts();
    contracts.value = data.data;
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isLoaded.value = true;
  }
}

function handleLogout() {
  localStorage.clear();
  window.location.reload();
  router.push({name: 'login'});
}

onMounted(loadContracts);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (companySettings.value?.logoUrl)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: companySettings.value.logoUrl,
            alt: "Logo",
            height: "40"
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(currentUser.value?.fullName), 1),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-grey",
          onClick: handleLogout
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("i", { class: "os-icon os-icon-signs-11 me-1" }, null, -1),
          _createTextVNode(" Logout ", -1)
        ]))])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (currentUser.value?.enabled && selectedDocumentId.value === null)
        ? (_openBlock(), _createBlock(BackButton, {
            key: 0,
            label: "Zur Anwendung",
            to: "/"
          }))
        : _createCommentVNode("", true),
      _cache[3] || (_cache[3] = _createElementVNode("h5", { class: "form-header mb-4" }, "Meine Verträge", -1)),
      (selectedDocumentId.value !== null)
        ? (_openBlock(), _createBlock(ContractDocumentView, {
            key: selectedDocumentId.value,
            "document-id": selectedDocumentId.value,
            "is-bsg-side": false,
            onBack: _cache[0] || (_cache[0] = ($event: any) => (selectedDocumentId.value = null)),
            onSigned: handleSigned
          }, null, 8, ["document-id"]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (currentUser.value?.enabled === false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("p", _hoisted_8, [
                    _createElementVNode("b", null, "Willkommen, " + _toDisplayString(currentUser.value?.firstName) + "!", 1)
                  ]),
                  (allSignedByUser.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Vielen Dank, Sie haben alle Vertragsunterlagen unterschrieben. Ihr Zugang wird freigeschaltet, sobald die BSG die Unterlagen ebenfalls unterschrieben hat. "))
                    : (_openBlock(), _createElementBlock("p", _hoisted_10, " Bitte öffnen Sie die Vertragsunterlagen und unterschreiben Sie diese. Ihr Zugang wird vollständig freigeschaltet, sobald alle Unterlagen von Ihnen und von der BSG unterschrieben sind. "))
                ]))
              : _createCommentVNode("", true),
            (!isLoaded.value)
              ? (_openBlock(), _createBlock(Loader, { key: 1 }))
              : _createCommentVNode("", true),
            (isLoaded.value && contracts.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Für Sie sind noch keine Vertragsunterlagen vorhanden. "))
              : _createCommentVNode("", true),
            _createVNode(ContractList, {
              contracts: contracts.value,
              "is-bsg-side": false,
              onOpen: _cache[1] || (_cache[1] = ($event: any) => (selectedDocumentId.value = $event))
            }, null, 8, ["contracts"])
          ], 64))
    ])
  ]))
}
}

})